import {Component, OnInit, Input} from "@angular/core";


@Component({
    selector: 'configuration-viewer',
    templateUrl: 'app/components/configurationviewer/configurationviewer.component.html',
    styleUrls: ['app/components/configurationviewer/configurationviewer.component.css']
})
export class ConfigurationViewerComponent implements OnInit {
    constructor() {
    }

    public ngOnInit() {
    }
}
